import { Component } from '@angular/core';
import {ConsentManagementCustomModule} from "../../consent-management-custom.module";
import { AnonymousConsentDialogComponent, IconModule, KeyboardFocusModule, SpinnerModule, FocusDirective, SpinnerComponent, IconComponent } from "@spartacus/storefront";
import {AsyncPipe} from "@angular/common";
import { I18nModule, TranslatePipe } from "@spartacus/core";
import { EfaConsentManagementFormComponent } from '../efa-consent-management-form/efa-consent-management-form.component';

@Component({
    selector: 'app-efa-anonymous-consent-dialog',
    templateUrl: './efa-anonymous-consent-dialog.component.html',
    imports: [FocusDirective, SpinnerComponent, IconComponent, EfaConsentManagementFormComponent, AsyncPipe, TranslatePipe]
})
export class EfaAnonymousConsentDialogComponent extends AnonymousConsentDialogComponent{

}
